
import WebService from "../WebService"
const Bootsale = {
    getPromos(params) {
        return WebService.get("/boostsales/promos/new?" + params)
    },
    getPromo(promo_id, params) {
        return WebService.get("/boostsales/promos/" + promo_id + "?" + params)
    },
    updatePromo(promo_id, data) {
        return WebService.post("/boostsales/promos/" + promo_id + `?e=${data.e}`, data)
    },
    addPromo(data) {
        return WebService.post("/boostsales/promos", data) 
    }
}
export default Bootsale